var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nx-picture"},[_c('div',{class:_vm.getStyle,on:{"click":_vm.handleClick}},_vm._l((_vm.filterImgList),function(item,index){return _c('nx-image',{key:index,attrs:{"src":item.url,"inner-text":item.innerText}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }